import axios from 'axios';
import { API_BASE_URL, REQUEST_TIMEOUT } from './config';

// Create axios instance
const apiClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: REQUEST_TIMEOUT,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor - Add website token to headers
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('family_tree_website_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - Handle errors
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        // Handle 401 errors by requesting new website token
        if (error.response?.status === 401) {
            // Clear invalid token
            localStorage.removeItem('family_tree_website_token');
        }

        // Handle other errors
        return Promise.reject(error);
    }
);

export default apiClient;
